import { useEffect, useState } from 'react';
import { API_BASE_URL } from '@/lib/api/apiClient';

export const BackendStatus = () => {
  const [status, setStatus] = useState<'checking' | 'online' | 'offline'>('checking');
  const [apiUrl, setApiUrl] = useState('');

  useEffect(() => {
    const checkBackend = async () => {
      const url = API_BASE_URL || '';
      setApiUrl(url ? url : window.location.origin);
      
      try {
        // Try to reach health endpoint
        const healthUrl = url ? `${url}/health` : '/health';
        const response = await fetch(healthUrl, { 
          method: 'GET',
          mode: 'cors',
          signal: AbortSignal.timeout(3000)
        });
        if (response.ok) {
          setStatus('online');
        } else {
          setStatus('offline');
        }
      } catch (error) {
        setStatus('offline');
      }
    };

    checkBackend();
    const interval = setInterval(checkBackend, 10000); // Check every 10 seconds

    return () => clearInterval(interval);
  }, []);

  if (status === 'checking') {
    return (
      <div className="fixed bottom-4 left-4 bg-yellow-100 border border-yellow-400 text-yellow-800 px-4 py-2 rounded-lg shadow-lg text-sm z-50">
        🔄 جاري التحقق من الخادم...
      </div>
    );
  }

  if (status === 'offline') {
    return (
      <div className="fixed bottom-4 left-4 bg-red-100 border border-red-400 text-red-800 px-4 py-2 rounded-lg shadow-lg text-sm z-50 max-w-sm">
        <div className="font-bold mb-1">⚠️ الخادم غير متاح</div>
        <div className="text-xs">
          {apiUrl && !apiUrl.includes('localhost') ? <>تأكد أن Backend يعمل على: <br /><code className="bg-red-200 px-1 rounded">{apiUrl}</code></> : 'تأكد أن الخادم يعمل.'}
        </div>
      </div>
    );
  }

  return (
    <div className="fixed bottom-4 left-4 bg-green-100 border border-green-400 text-green-800 px-4 py-2 rounded-lg shadow-lg text-sm z-50">
      ✅ الخادم متاح
    </div>
  );
};
